export default function isBrightColor(hex) {
  hex = hex.replace('#', '')

  // Convert 3-digit hex to 6-digit hex if needed
  if (hex.length === 3) {
    hex = hex.split('').map(x => x + x).join('')
  }

  // Extract the red, green, and blue values
  const r = Number.parseInt(hex.substring(0, 2), 16)
  const g = Number.parseInt(hex.substring(2, 4), 16)
  const b = Number.parseInt(hex.substring(4, 6), 16)

  // Calculate relative luminance
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b

  // Threshold for determining brightness (can be adjusted)
  return luminance > 220
}
